module.exports = __webpack_public_path__ + "assets/img/four.01275d84.png";